import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import FormFieldError from "components/common/form_error/form_field_error";
import React, { useState } from "react";

const FormPasswordField = ({
  label,
  value,
  onChange,
  submitted,
  errorMessage,
  required = false,
  hasError = false,
  ...rest
}) => {
  const [error, setError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handlePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleChange = (event) => {
    const inputValue = event;
    onChange(inputValue);
    setError(false);
  };

  return (
    <>
      <TextField
        {...rest}
        label={label}
        value={value}
        margin="normal"
        variant="outlined"
        required={required}
        onChange={handleChange}
        error={error || hasError}
        autoComplete="current-password"
        type={showPassword ? "text" : "password"}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handlePasswordVisibility} edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {hasError && (
        <FormFieldError
          errorMessage={errorMessage || `${label} is required.`}
        />
      )}
    </>
  );
};

export default FormPasswordField;
